module.exports = __webpack_public_path__ + "img/Dhaval_Sarvaiya.66c4c8f9.jpg";